export const formConfig = {
    name: 'erpDialog',
    fields: [
        {
            label: '集团编码',
            prop: 'originalGroupCode',
            rule: [
                { required: true, message: '集团编码不能为空', trigger: ['change', 'blur'] }
            ],
            type: 'input'
        },
        {
            label: '业务实体编码',
            name: '业务实体编码',
            prop: 'customerAccountCode',
            value: 'customerAccountCode',
            type: 'advance',
            visible: true,
            rule: [
                { required: true, message: '业务实体不能为空', trigger: ['change', 'blur'] }
            ],
            advanceConfig: [
                { prop: 'customerAccount', value: '业务实体编码' }
            ],
            tableConfig: [
                { prop: 'customerAccount', value: '业务实体编码' },
                { prop: 'customerAccountName', value: '业务实体名称' },
                {
                    prop: 'approveStatus',
                    value: '审批状态',
                    type: 'select',
                    optionsKey: 'CRM_ACCOUNT_APPROVE_STATUS'
                },
                {
                    prop: 'isErpSynchronize',
                    value: '推送ERP状态',
                    type: 'select',
                    optionsKey: 'LCRM_ERP_SYNCHRONIZE_STATUS'
                }

            ],
            prefix: '/api-lcrm',
            method: 'post',
            advanceUrl: `/customer/account/query`,
            cbParams: ['customerAccount#customerAccountCode', 'customerAccountName'],
            beforeRequest: (params) => {
                return params;
            }
            // isCheck:是否校验客户主体 projectType:报价项目类型 isLinkOppo:是否校验关联商机
        },
        {
            label: '推送状态',
            prop: 'isErpSynchronize',
            type: 'select',
            visible: true,
            disabled: true,
            rule: [
                { required: true, message: '推送状态不能为空', trigger: ['change', 'blur'] }
            ],
            optionsKey: 'LCRM_ERP_SYNCHRONIZE_STATUS'
        },
        {
            label: '失效标记',
            prop: 'effectStatus',
            type: 'select',
            visible: true,
            disabled: true,
            rule: [
                { required: true, message: '失效标记不能为空', trigger: ['change', 'blur'] }
            ],
            optionsKey: 'EFFECT_STATUS'
        }

    ],
    height: 325
};
